import Link from '@cloudscape-design/components/link';
import { safeHref } from '../utils/format';

/**
 * Renders a URL from an untrusted source (e.g. a report's content reference) as
 * an external link only when it has a safe http(s) scheme; otherwise shows the
 * raw value as plain text so a `javascript:`/`data:` URL can't become a live
 * link. Cloudscape's Link does no scheme sanitization of its own, so the gate
 * lives here.
 */
export function SafeExternalLink({ url }: { url: string }) {
  const href = safeHref(url);
  return href ? (
    <Link href={href} external>
      {url}
    </Link>
  ) : (
    <>{url}</>
  );
}
